import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '~/hooks';
import { factoryPaymentMethodsKey } from '../factories';
import { paymentsService } from '../paymentsService';

export const useGetPaymentMethods = (
  officeId?: string,
  options: { enabled?: boolean } = {},
) => {
  const selectedOfficeId = useAppSelector((state) => state.user.selectedOfficeId);
  const effectiveOfficeId = officeId ?? selectedOfficeId ?? undefined;

  const query = useQuery({
    queryKey: factoryPaymentMethodsKey({ officeId: effectiveOfficeId }),
    queryFn: () => paymentsService.getPaymentMethods(effectiveOfficeId),
    enabled: options.enabled ?? true,
    staleTime: 45 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    ...query,
    paymentMethods: query.data ?? [],
  };
};
